var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eagleStrike pa wih80 ht60"},[_c('Header',{attrs:{"title":"联击"}}),_c('Content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }